import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_axios_2e0a522c from 'nuxt_plugin_axios_2e0a522c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_bootstrapvue_12f4445b from 'nuxt_plugin_bootstrapvue_12f4445b' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_vuegeolocationapi_fb9fbfd4 from 'nuxt_plugin_vuegeolocationapi_fb9fbfd4' // Source: ./vue-geolocation-api.js (mode: 'all')
import nuxt_plugin_pluginutils_1e7d398f from 'nuxt_plugin_pluginutils_1e7d398f' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2a159f1a from 'nuxt_plugin_pluginrouting_2a159f1a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_21e99ad6 from 'nuxt_plugin_pluginmain_21e99ad6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_2a91b402 from 'nuxt_plugin_gtm_2a91b402' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_toast_0b8ac24a from 'nuxt_plugin_toast_0b8ac24a' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_vuesocialsharingplugin_910681b6 from 'nuxt_plugin_vuesocialsharingplugin_910681b6' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_nuxtvuemultiselect_57fc3cc8 from 'nuxt_plugin_nuxtvuemultiselect_57fc3cc8' // Source: ./nuxt-vue-multiselect.js (mode: 'all')
import nuxt_plugin_vuescrollto_772c2a5d from 'nuxt_plugin_vuescrollto_772c2a5d' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_pluginslayouts_7c5d9e32 from 'nuxt_plugin_pluginslayouts_7c5d9e32' // Source: ./typo3/plugins.layouts.js (mode: 'all')
import nuxt_plugin_pluginscomponents_59c19a68 from 'nuxt_plugin_pluginscomponents_59c19a68' // Source: ./typo3/plugins.components.js (mode: 'all')
import nuxt_plugin_middlewarecontext_c6ccde4e from 'nuxt_plugin_middlewarecontext_c6ccde4e' // Source: ./typo3/middleware.context.js (mode: 'all')
import nuxt_plugin_middlewarei18n_6c43d1c8 from 'nuxt_plugin_middlewarei18n_6c43d1c8' // Source: ./typo3/middleware.i18n.js (mode: 'all')
import nuxt_plugin_storeindex_48d9e2dd from 'nuxt_plugin_storeindex_48d9e2dd' // Source: ./typo3/store.index.js (mode: 'all')
import nuxt_plugin_pluginscontext_849067fe from 'nuxt_plugin_pluginscontext_849067fe' // Source: ./typo3/plugins.context.js (mode: 'all')
import nuxt_plugin_image_19114f27 from 'nuxt_plugin_image_19114f27' // Source: ./image.js (mode: 'all')
import nuxt_plugin_lazySizes_3370e2b8 from 'nuxt_plugin_lazySizes_3370e2b8' // Source: ./lazySizes.js (mode: 'all')
import nuxt_plugin_StringUtility_2b26f580 from 'nuxt_plugin_StringUtility_2b26f580' // Source: ../plugins/utilities/StringUtility (mode: 'all')
import nuxt_plugin_ObjectUtility_55d06292 from 'nuxt_plugin_ObjectUtility_55d06292' // Source: ../plugins/utilities/ObjectUtility (mode: 'all')
import nuxt_plugin_components_6fb0430c from 'nuxt_plugin_components_6fb0430c' // Source: ../plugins/components (mode: 'all')
import nuxt_plugin_vueformulate_7bd14f1a from 'nuxt_plugin_vueformulate_7bd14f1a' // Source: ../plugins/vue-formulate (mode: 'all')
import nuxt_plugin_backendlayouts_d1056bcc from 'nuxt_plugin_backendlayouts_d1056bcc' // Source: ../plugins/backend-layouts (mode: 'all')
import nuxt_plugin_fontawesomeicons_0768dc8b from 'nuxt_plugin_fontawesomeicons_0768dc8b' // Source: ../plugins/fontawesome-icons (mode: 'all')
import nuxt_plugin_foldable_049cfe51 from 'nuxt_plugin_foldable_049cfe51' // Source: ../plugins/foldable (mode: 'all')
import nuxt_plugin_googlemaps_ab35f716 from 'nuxt_plugin_googlemaps_ab35f716' // Source: ../plugins/google-maps (mode: 'client')
import nuxt_plugin_vueglobalfilters_6746ee24 from 'nuxt_plugin_vueglobalfilters_6746ee24' // Source: ../plugins/vue-global-filters (mode: 'all')
import nuxt_plugin_fullpage_4279eb14 from 'nuxt_plugin_fullpage_4279eb14' // Source: ../plugins/fullpage (mode: 'client')
import nuxt_plugin_aos_5e4622cf from 'nuxt_plugin_aos_5e4622cf' // Source: ../plugins/aos (mode: 'client')
import nuxt_plugin_lightbox_2e376e6b from 'nuxt_plugin_lightbox_2e376e6b' // Source: ../plugins/lightbox (mode: 'client')
import nuxt_plugin_parallax_38e9730d from 'nuxt_plugin_parallax_38e9730d' // Source: ../plugins/parallax (mode: 'client')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_jsonld_593ee954 from 'nuxt_plugin_jsonld_593ee954' // Source: ../plugins/jsonld (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":null,"title":"Immobilien Service Deutschland","htmlAttrs":{"lang":"de"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"theme-color","content":"#004ea0"},{"name":"google-site-verification","content":"ld7RnSaE2KLwiB1T_52RTbtQgV_NJ0WblZ48BbgnU4E"},{"hid":"title","name":"title","content":"Immobilien Service Deutschland"},{"hid":"ogTitle","name":"og:title","content":"Immobilien Service Deutschland"},{"hid":"ogSiteName","name":"og:site_name","content":"Immobilien Service Deutschland"},{"hid":"ogDescription","name":"og:description","content":"Immobilien Service Deutschland"},{"hid":"ogImage","name":"og:image","content":"\u002Fisd-logo.svg"},{"name":"application-name","content":"Immobilien Service Deutschland"},{"name":"apple-mobile-web-app-title","content":"Immobilien Service Deutschland"},{"name":"msapplication-TileColor","content":"#004EA0"},{"name":"msapplication-TileImage","content":"mstile-144x144.png"},{"name":"msapplication-square70x70logo","content":"mstile-70x70.png"},{"name":"msapplication-square150x150logo","content":"mstile-150x150.png"},{"name":"msapplication-wide310x150logo","content":"mstile-310x150.png"},{"name":"msapplication-square310x310logo","content":"mstile-310x310.png"},{"dataprivacyproxyserver":"https:\u002F\u002Fprivacy-proxy-server.usercentrics.eu"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon-precomposed","sizes":"90x90","href":"apple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","href":"android-chrome-192x192.png","sizes":"196x196"},{"rel":"icon","type":"image\u002Fpng","href":"android-chrome-512x512.png","sizes":"512x512"},{"rel":"icon","type":"image\u002Fpng","href":"favicon-32x32.png","sizes":"32x32"},{"rel":"icon","type":"image\u002Fpng","href":"favicon-16x16.png","sizes":"16x16"}],"script":[{"id":"usercentrics-cmp","type":"application\u002Fjavascript","charset":"UTF-8","data-settings-id":"_DwhpgQqS-kswZ","data-tcf-enabled":true,"src":"https:\u002F\u002Fapp.usercentrics.eu\u002Fbrowser-ui\u002Flatest\u002Floader.js","async":true},{"rel":"preload","type":"application\u002Fjavascript","src":"https:\u002F\u002Fprivacy-proxy.usercentrics.eu\u002Flatest\u002Fuc-block.bundle.js","async":true},{"id":"_etLoader","type":"text\u002Fjavascript","charset":"UTF-8","data-block-cookies":"true","data-respect-dnt":"true","data-secure-code":"aoE4a3","src":"\u002F\u002Fcode.etracker.com\u002Fcode\u002Fe.js","async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-W45FZHP&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_axios_2e0a522c === 'function') {
    await nuxt_plugin_axios_2e0a522c(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_12f4445b === 'function') {
    await nuxt_plugin_bootstrapvue_12f4445b(app.context, inject)
  }

  if (typeof nuxt_plugin_vuegeolocationapi_fb9fbfd4 === 'function') {
    await nuxt_plugin_vuegeolocationapi_fb9fbfd4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_1e7d398f === 'function') {
    await nuxt_plugin_pluginutils_1e7d398f(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2a159f1a === 'function') {
    await nuxt_plugin_pluginrouting_2a159f1a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_21e99ad6 === 'function') {
    await nuxt_plugin_pluginmain_21e99ad6(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2a91b402 === 'function') {
    await nuxt_plugin_gtm_2a91b402(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_0b8ac24a === 'function') {
    await nuxt_plugin_toast_0b8ac24a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_910681b6 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_910681b6(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtvuemultiselect_57fc3cc8 === 'function') {
    await nuxt_plugin_nuxtvuemultiselect_57fc3cc8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_772c2a5d === 'function') {
    await nuxt_plugin_vuescrollto_772c2a5d(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginslayouts_7c5d9e32 === 'function') {
    await nuxt_plugin_pluginslayouts_7c5d9e32(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginscomponents_59c19a68 === 'function') {
    await nuxt_plugin_pluginscomponents_59c19a68(app.context, inject)
  }

  if (typeof nuxt_plugin_middlewarecontext_c6ccde4e === 'function') {
    await nuxt_plugin_middlewarecontext_c6ccde4e(app.context, inject)
  }

  if (typeof nuxt_plugin_middlewarei18n_6c43d1c8 === 'function') {
    await nuxt_plugin_middlewarei18n_6c43d1c8(app.context, inject)
  }

  if (typeof nuxt_plugin_storeindex_48d9e2dd === 'function') {
    await nuxt_plugin_storeindex_48d9e2dd(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginscontext_849067fe === 'function') {
    await nuxt_plugin_pluginscontext_849067fe(app.context, inject)
  }

  if (typeof nuxt_plugin_image_19114f27 === 'function') {
    await nuxt_plugin_image_19114f27(app.context, inject)
  }

  if (typeof nuxt_plugin_lazySizes_3370e2b8 === 'function') {
    await nuxt_plugin_lazySizes_3370e2b8(app.context, inject)
  }

  if (typeof nuxt_plugin_StringUtility_2b26f580 === 'function') {
    await nuxt_plugin_StringUtility_2b26f580(app.context, inject)
  }

  if (typeof nuxt_plugin_ObjectUtility_55d06292 === 'function') {
    await nuxt_plugin_ObjectUtility_55d06292(app.context, inject)
  }

  if (typeof nuxt_plugin_components_6fb0430c === 'function') {
    await nuxt_plugin_components_6fb0430c(app.context, inject)
  }

  if (typeof nuxt_plugin_vueformulate_7bd14f1a === 'function') {
    await nuxt_plugin_vueformulate_7bd14f1a(app.context, inject)
  }

  if (typeof nuxt_plugin_backendlayouts_d1056bcc === 'function') {
    await nuxt_plugin_backendlayouts_d1056bcc(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesomeicons_0768dc8b === 'function') {
    await nuxt_plugin_fontawesomeicons_0768dc8b(app.context, inject)
  }

  if (typeof nuxt_plugin_foldable_049cfe51 === 'function') {
    await nuxt_plugin_foldable_049cfe51(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlemaps_ab35f716 === 'function') {
    await nuxt_plugin_googlemaps_ab35f716(app.context, inject)
  }

  if (typeof nuxt_plugin_vueglobalfilters_6746ee24 === 'function') {
    await nuxt_plugin_vueglobalfilters_6746ee24(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fullpage_4279eb14 === 'function') {
    await nuxt_plugin_fullpage_4279eb14(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aos_5e4622cf === 'function') {
    await nuxt_plugin_aos_5e4622cf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lightbox_2e376e6b === 'function') {
    await nuxt_plugin_lightbox_2e376e6b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_parallax_38e9730d === 'function') {
    await nuxt_plugin_parallax_38e9730d(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_593ee954 === 'function') {
    await nuxt_plugin_jsonld_593ee954(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
